// SideNav.js
import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
} from '@mui/material';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import EditIcon from '@mui/icons-material/Edit';
import QuizIcon from '@mui/icons-material/Quiz';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import AssignmentIcon from '@mui/icons-material/Assignment';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import CodeIcon from '@mui/icons-material/Code';
import SchemaIcon from '@mui/icons-material/Schema';
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { alpha } from '@mui/material/styles';

const navItems = [
  { path: '/generate',            label: 'Course Builder',   icon: <SchoolIcon /> },
  { path: '/edit',                label: 'Course Editor',    icon: <EditIcon /> },
  { divider: true },
  { path: '/selfquiz-generator',  label: 'Quiz Builder',     icon: <QuizIcon /> },
  { path: '/code-generator',      label: 'Code Example',     icon: <CodeIcon /> },
  { path: '/insight-generator',   label: 'Concept Explainer',icon: <LightbulbIcon /> },
  { divider: true },
  { path: '/simulation-generator',label: 'Sim Builder',      icon: <PrecisionManufacturingIcon /> },
  { path: '/diagram-generator',   label: 'Diagram Builder',  icon: <SchemaIcon /> },
  { path: '/presentation-generator',label: 'Deck Builder',   icon: <SlideshowIcon /> },
  { divider: true },
  { path: '/reference-uploads',   label: 'Upload Reference', icon: <UploadFileIcon /> },
  { path: '/exam-generator',      label: 'Exam Builder',     icon: <AssignmentIcon /> },
  { path: '/teacher-api-keys',    label: 'API Keys',         icon: <VpnKeyIcon /> },
  { path: '/publish',             label: 'Publish to Google Classroom',          icon: <CloudUploadTwoToneIcon /> },
  { path: '/me-publish',         label: 'Publish to MindEngage LMS',            icon: <CloudUploadTwoToneIcon /> }, 
  { path: '/download-course',     label: 'Download Course',  icon: <CloudDownloadIcon /> },
];

const SideNav = ({ onItemClick }) => {
  const navigate  = useNavigate();
  const location  = useLocation();

  return (
    <Box sx={{ width: 240 }}>
      {/* Spacer to push items below the TopBar */}
      <Toolbar />
      <List>
        {navItems.map((item, idx) =>
          item.divider ? (
            <Divider key={idx} />
          ) : (
            <ListItem disablePadding key={item.path}>
              <ListItemButton
                component={Link}
                to={item.path}
                onClick={() => { navigate(item.path); if (onItemClick) onItemClick(); }}
                selected={location.pathname.startsWith(item.path)}
                sx={{
                  // Styles for the selected (active) list item
                  '&.Mui-selected': {
                    // Use a light, semi-transparent version of the primary color for the background
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
                    // Change the text color to the main primary color for readability
                    color: (theme) => theme.palette.primary.main,
                    // Make the font bold to give it more emphasis
                    fontWeight: 'fontWeightBold',
                    // Ensure the icon also uses the main primary color
                    '& .MuiListItemIcon-root': {
                      color: (theme) => theme.palette.primary.main,
                    },
                  },
                  // Optional: Slightly darken the light background on hover for better feedback
                  '&.Mui-selected:hover': {
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.20),
                  },
                }}
              >
                <ListItemIcon> {item.icon} </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
      <Divider />
    </Box>
  );
};

export default SideNav;
